<template>
  <div class="wrapper">
    <div class="bg-card">
      <div class="d-flex justify-content-between">
        <strong>{{ $t('pages.user-cv.experience.title', 'Experience') }}</strong>
        <b-button
          v-if="$route.name == 'my-cv'"
          class="cv-button"
          @click="$emit('experienceModalOpen')"
        >
          {{ $t('pages.user-cv.experience.edit-button', 'Edit experience') }}
        </b-button>
      </div>
      <hr>
      <div class="d-flex justify-content-between">
        <div v-if="experience">
          <div
            v-for="element in JSON.parse(experience)"
            :key="element.id"
            class="mb-3"
          >
            <div>
              <h1
                class="mb-0"
                style="font-size: 1.1rem !important"
              >
                {{
                  $t(
                    'pages.user-cv.experience.entry',
                    '{company} at {position}',
                    {
                      position: element.position,
                      company: element.company,
                    }
                  )
                }}
              </h1>
              <div style="color: #999;">
                {{ element.levelSelected }}
              </div>
              <div style="color: #999; font-size: 0.9rem">
                {{ element.startDate }} -
                <span v-if="!element.ongoingJob">{{ element.endDate }}</span>
                <span v-else>{{ $t('generic.present', 'Present') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    experience: {
      type: String,
      default: ""
    },
  }
}
</script>
